import api from "./axios";

export type EvalItemPayload = {
  alumnoId: number;
  puntualidad: number;
  motivacion: number;
  atencion: number;
  deberes: number;
  nivel: number;
  observaciones?: string | null;
};

export type EvaluacionesReservaResponse = {
  reservaId: number;
  profesorId: number;
  items: EvalItemPayload[];
};

export async function getEvaluacionesDeReserva(reservaId: number) {
  const { data } = await api.get<EvaluacionesReservaResponse>(`/evaluaciones/reserva/${reservaId}`);
  return data;
}

export async function postEvaluacionesDeReserva(reservaId: number, items: EvalItemPayload[]) {
  const { data } = await api.post(`/evaluaciones/reserva/${reservaId}`, {
    items,
  });
  return data as { ok: true };
}
